module.exports = __webpack_public_path__ + "media/images/countrysquared/tr-ba0ca7351b7d0afa7ae4f59d3b9cc258.svg";